import TextMessage from "./textMessage.container";

export default TextMessage;
